import React, { useState, useEffect } from "react";
import { Button } from "../components/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addInterest, removeInterest } from "../store/userSlice";
import { INTEREST } from "../constants/interests";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import config from "../config";
import { toast } from "react-toastify";
import GeolocationRequest from "../components/GeolocationRequest";

function Step5({ setStep }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate(); // Используем хук для получения axios с токеном
  const registrationData = useSelector((state) => state.user.registrationData);
  const interests = useSelector(
    (state) => state.user.registrationData.interests
  );
  const { telegramId } = useSelector((state) => state.auth);
  const [disabled, setDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showGeolocationRequest, setShowGeolocationRequest] = useState(false);

  useEffect(() => {
    if (interests.length >= 5) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [interests]);

  const addOption = (optionId) => {
    if (interests.includes(optionId)) {
      dispatch(removeInterest(optionId));
    } else {
      dispatch(addInterest(optionId));
    }
  };

  // Функция для сохранения геолокации на сервере
  const saveGeolocation = async (coordinates) => {
    try {
      console.log("📍 [Step5] Сохраняем геолокацию:", coordinates);

      const response = await axiosPrivate.put(
        config.API.USERS.UPDATE_LOCATION,
        {
          latitude: coordinates.latitude,
          longitude: coordinates.longitude,
          accuracy: coordinates.accuracy,
        }
      );

      console.log("✅ [Step5] Геолокация сохранена:", response.data);
      return true;
    } catch (error) {
      console.error("❌ [Step5] Ошибка сохранения геолокации:", error);
      return false;
    }
  };

  // Обработчик завершения запроса геолокации
  const handleGeolocationComplete = async (coordinates) => {
    await saveGeolocation(coordinates);
    setShowGeolocationRequest(false);
    navigate("/meet");
  };

  // Обработчик пропуска геолокации
  const handleGeolocationSkip = () => {
    setShowGeolocationRequest(false);
    navigate("/meet");
  };

  const saveDataAndNext = async () => {
    if (interests.length >= 5) {
      try {
        setIsSubmitting(true);

        console.log("📤 [Step5] Обновление интересов:", interests);

        // Проверяем токен
        const authState = localStorage.getItem("authState");
        console.log(
          "🔑 [Step5] AuthState из localStorage:",
          authState ? "есть" : "НЕТ"
        );
        if (authState) {
          const parsed = JSON.parse(authState);
          console.log("🔑 [Step5] Токен:", parsed.auth_token ? "есть" : "НЕТ");
        }

        // Отправляем только интересы для обновления существующего пользователя (PUT!)
        const response = await axiosPrivate.put(
          config.API.USERS.UPDATE_INTERESTS,
          {
            interests: interests,
          }
        );

        console.log("✅ [Step5] Интересы обновлены:", response.data);

        if (response.data) {
          // После обновления интересов показываем запрос геолокации
          setShowGeolocationRequest(true);
        }
      } catch (error) {
        console.error("❌ [Step5] Ошибка обновления интересов:", error);
        console.error("❌ [Step5] Error response:", error.response?.data);
        console.error("❌ [Step5] Error status:", error.response?.status);

        let errorMessage = "Произошла ошибка при обновлении интересов";

        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        alert(`Ошибка: ${errorMessage}`);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      alert("Выберите минимум 5 интересов!");
    }
  };

  const options = INTEREST;

  return (
    <div className="flex flex-col items-center w-full px-4 h-[100%] overflow-x-hidden">
      {/* Модальное окно запроса геолокации */}
      {showGeolocationRequest && (
        <GeolocationRequest
          onComplete={handleGeolocationComplete}
          onSkip={handleGeolocationSkip}
        />
      )}

      <h1 className="font-raleway font-semibold mt-6 text-white text-[20px]">
        Добавьте ваши интересы
      </h1>
      <h1 className="font-raleway font-light mt-2 text-white text-center text-[16px]">
        Выберите не менее 5 интересов, чтобы поделиться ими с другими
        пользователями
      </h1>
      <div className="flex flex-wrap gap-[8px] mt-[16px] mb-[100px]">
        {options.map((option, index) => (
          <div
            key={index}
            onClick={() => addOption(option.id)}
            className={`w-auto ${
              option.id === "Права людей с ограниченными возможностями"
                ? "text-[15px] p-2"
                : "p-3 text-[18px]"
            } h-[48px] rounded-[400px] flex justify-center items-center font-light text-white cursor-pointer transition-all
              ${
                interests.includes(option.id)
                  ? "bg-[#043939] border-[1.5px] border-[#a1f69e]"
                  : "bg-[#022424] border-[1px] border-[#233636]"
              }`}
          >
            <span>{option.id}</span>
          </div>
        ))}
      </div>
      <div className="fixed bottom-[20px] z-10">
        <Button onClick={saveDataAndNext} id="burtxteoic" disabled={disabled || isSubmitting}>
          {isSubmitting ? "Отправка..." : "Начать знакомства"}
        </Button>
      </div>
    </div>
  );
}

export default Step5;
